/**
 * ./exercise7/data/articles.js
 *
 * This module loads **book articles** from the public folder and stores
 * them as an array of objects. Each object contains:
 * - Book cover image
 * - Book title
 * - Extracted text
 * - Read status
 *
 */

// import TheHappyPrince from "./book-covers/TheHappyPrince.jpg";
// import TheWizardofOz from "./book-covers/TheWizardofOz.jpg";
// import AnneofGreenGables from "./book-covers/AnneofGreenGables.jpg";
// import TreasureIsland from "./book-covers/TreasureIsland.jpg";
// import AChristmasCarol from "./book-covers/AChristmasCarol.jpg";
// import AliceAdventureinWonderland from "./book-covers/AliceAdventureinWonderland.jpg";
// import PeterPan from "./book-covers/PeterPan.jpg";
// import ThroughtheLookingGlass from "./book-covers/ThroughtheLookingGlass.jpg";
// import TheScarletLetter from "./book-covers/TheScarletLetter.jpg";
// import TheSecretGarden from "./book-covers/TheSecretGarden.jpg";
// import HuntingforHiddenGold from "./book-covers/HuntingforHiddenGold.jpg";
// import AttheBackoftheNorthWind from "./book-covers/AttheBackoftheNorthWind.jpg";
// import Bambi from "./book-covers/Bambi.jpg";
// import OzmaofOz from "./book-covers/OzmaofOz.jpg";
// import TheBlueBird from "./book-covers/TheBlueBird.jpg";
// import TheMagicCity from "./book-covers/TheMagicCity.jpg";
// import TheRailwayChildren from "./book-covers/TheRailwayChildren.jpg";
// import TheSecretoftheOldMill from "./book-covers/TheSecretoftheOldMill.jpg";
// import TheWaterBabies from "./book-covers/TheWaterBabies.jpg";

// `loadFile()`: Loads and processes book content from a text file.
const loadFile = async (file) => {
  const response = await fetch(file); // Fetch from public folder
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
  const text = await response.text();

  const normalizedText = text.replace(/\r\n|\r/g, "\n");

  // Split into paragraphs
  const parsedParagraphs = normalizedText
    .split(/\n\s*\n/) // Split by double line breaks
    .map((p) => p.trim()) // Trim each paragraph
    .filter((p) => p.length > 0); // Remove empty lines

  const paragraphs = parsedParagraphs.map((p) => p.replace(/\n/g, " "));
  console.log(paragraphs);

  return paragraphs;
};

// `articles[]`: Stores book data in an array.
const articles = [
  {
    key: 0, // Unique identifier
    // image: TheWizardofOz, // Cover image of the book
    name: "TheWizardofOz", // Title of the book.
    text: await loadFile("/article-text/TheWizardofOz.txt"), // Content loaded via `loadFile()`.
    read: false, // Boolean flag to track if the book has been read.
  },
  {
    key: 1,
    // image: TheHappyPrince,
    name: "TheHappyPrince",
    text: await loadFile("/article-text/TheHappyPrince.txt"),
    read: false,
  },
  {
    key: 3,
    // image: AnneofGreenGables,
    name: "AnneofGreenGables",
    text: await loadFile("/article-text/AnneofGreenGables.txt"),
    read: false,
  },
  {
    key: 4,
    // image: TreasureIsland,
    name: "TreasureIsland",
    text: await loadFile("/article-text/TreasureIsland.txt"),
    read: false,
  },
  {
    key: 5,
    // image: AChristmasCarol,
    name: "AChristmasCarol",
    text: await loadFile("/article-text/AChristmasCarol.txt"),
    read: false,
  },
  {
    key: 6,
    // image: AliceAdventureinWonderland,
    name: "AliceAdventureinWonderland",
    text: await loadFile("/article-text/AliceAdventureinWonderland.txt"),
    read: false,
  },
  {
    key: 7,
    // image: PeterPan,
    name: "PeterPan",
    text: await loadFile("/article-text/PeterPan.txt"),
    read: false,
  },
  {
    key: 8,
    // image: ThroughtheLookingGlass,
    name: "ThroughtheLookingGlass",
    text: await loadFile("/article-text/ThroughtheLookingGlass.txt"),
    read: false,
  },
  {
    key: 9,
    // image: TheScarletLetter,
    name: "TheScarletLetter",
    text: await loadFile("/article-text/TheScarletLetter.txt"),
    read: false,
  },
  {
    key: 10,
    // image: TheSecretGarden,
    name: "TheSecretGarden",
    text: await loadFile("/article-text/TheSecretGarden.txt"),
    read: false,
  },
  {
    key: 11,
    // image: HuntingforHiddenGold,
    name: "HuntingforHiddenGold",
    text: await loadFile("/article-text/HuntingforHiddenGold.txt"),
    read: false,
  },
  {
    key: 12,
    // image: AttheBackoftheNorthWind,
    name: "AttheBackoftheNorthWind",
    text: await loadFile("/article-text/AttheBackoftheNorthWind.txt"),
    read: false,
  },
  {
    key: 13,
    // image: Bambi,
    name: "Bambi",
    text: await loadFile("/article-text/Bambi.txt"),
    read: false,
  },
  {
    key: 14,
    // image: OzmaofOz,
    name: "OzmaofOz",
    text: await loadFile("/article-text/OzmaofOz.txt"),
    read: false,
  },
  {
    key: 15,
    // image: TheBlueBird,
    name: "TheBlueBird",
    text: await loadFile("/article-text/TheBlueBird.txt"),
    read: false,
  },
  {
    key: 16,
    // image: TheMagicCity,
    name: "TheMagicCity",
    text: await loadFile("/article-text/TheMagicCity.txt"),
    read: false,
  },
  {
    key: 17,
    // image: TheRailwayChildren,
    name: "TheRailwayChildren",
    text: await loadFile("/article-text/TheRailwayChildren.txt"),
    read: false,
  },
  {
    key: 18,
    // image: TheSecretoftheOldMill,
    name: "TheSecretoftheOldMill",
    text: await loadFile("/article-text/TheSecretoftheOldMill.txt"),
    read: false,
  },
  {
    key: 19,
    // image: TheWaterBabies,
    name: "TheWaterBabies",
    text: await loadFile("/article-text/TheWaterBabies.txt"),
    read: false,
  },
];

export default articles;
